// extracted by mini-css-extract-plugin
export default {"galleryFloatingToolBar":"GalleryFloatingToolBar_galleryFloatingToolBar__wVzB9","divider":"GalleryFloatingToolBar_divider__Bztso","vertical":"GalleryFloatingToolBar_vertical__9dSGu"};